export const PARTNER_DISABLED_ERROR = 'disabled_partner'
export const ALREADY_REGISTERED_ERROR = 'already_registered'
